<template>
<EntityReport entity="ReportEnviron" />
</template>

<script>
export default {

}
</script>
